/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcRouteV1RoutingRuleEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_ROUTE_V1_ROUTING_RULE_EVENT_ENTITY_NAME = 'exc.route.v1.RoutingRuleEvent';
export const excRouteV1RoutingRuleEventEntity = new schema.Entity<ExcRouteV1RoutingRuleEvent>(EXC_ROUTE_V1_ROUTING_RULE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcRouteV1RoutingRuleEvent) => `${entity.metadata?.eventId}` });

